const SolanaLogo = ({ className = "w-6 h-6" }) => (
  <svg
    className={className}
    viewBox="0 0 397 311"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M64.6406 237.916L98.6427 274.387C99.9033 275.721 101.461 276.771 103.198 277.471C104.935 278.17 106.812 278.504 108.708 278.452H380.901C384.215 278.452 385.943 274.506 383.57 272.133L349.568 235.662C348.307 234.328 346.75 233.278 345.013 232.579C343.276 231.879 341.399 231.545 339.503 231.597H67.3106C63.9965 231.597 62.2683 235.543 64.6406 237.916Z"
      fill="url(#paint0_linear_solana)"
    />
    <path
      d="M64.6406 74.0439L98.6427 110.515C99.9033 111.849 101.461 112.899 103.198 113.599C104.935 114.298 106.812 114.632 108.708 114.58H380.901C384.215 114.58 385.943 110.634 383.57 108.261L349.568 71.79C348.307 70.4563 346.75 69.4063 345.013 68.7069C343.276 68.0074 341.399 67.6736 339.503 67.7251H67.3106C63.9965 67.7251 62.2683 71.6712 64.6406 74.0439Z"
      fill="url(#paint1_linear_solana)"
    />
    <path
      d="M349.568 155.861L315.566 192.332C314.305 193.666 312.748 194.716 311.011 195.415C309.274 196.115 307.397 196.449 305.501 196.397H33.308C29.9939 196.397 28.2657 192.451 30.638 190.078L64.6401 153.607C65.9007 152.274 67.4584 151.224 69.1954 150.524C70.9324 149.824 72.8094 149.491 74.7054 149.543H346.898C350.212 149.543 351.94 153.489 349.568 155.861Z"
      fill="url(#paint2_linear_solana)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_solana"
        x1="41.1667"
        y1="254.974"
        x2="380.901"
        y2="254.974"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_solana"
        x1="41.1667"
        y1="91.1023"
        x2="380.901"
        y2="91.1023"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_solana"
        x1="30.638"
        y1="172.97"
        x2="370.372"
        y2="172.97"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00FFA3" />
        <stop offset="1" stopColor="#DC1FFF" />
      </linearGradient>
    </defs>
  </svg>
);

export default SolanaLogo; 